import { COOKIE } from 'Constants/constants';

import { isAffiliate } from './conciergeUtils';

export const isNormalUser = (cookies: any) => !isAffiliate(cookies);

export const isSignedIn = (cookies: any) =>
	cookies?.[COOKIE.IS_SIGNED_IN] === 'true';
